const TEMPORAL_CHART_PALETTE = [
    { color: "#037CB7", borderColor: "#037CB7" },
    { color: "#E7F3F4", borderColor: "#0199A6" },
    { color: "#4DB8C1", borderColor: "#016B74" },
    { color: "#015294", borderColor: "#015294" },
    { color: "#8CC342", borderColor: "#318040" },
    { color: "#E99625", borderColor: "#B75D24" },
    { color: "#C0CF30", borderColor: "#899D3B" },
    { color: "#5E88A1", borderColor: "#335E7A" },
    { color: "#FAC832", borderColor: "#D67921" },
    { color: "#0199A6", borderColor: "#017F90" },
    { color: "#318040", borderColor: "#0A6A36" },
    { color: "#78A5D1", borderColor: "#3273AF" },
    { color: "#D67921", borderColor: "#B75D24" },
    { color: "#7CC6CA", borderColor: "#017F90" },
    { color: "#B6D991", borderColor: "#318040" },
    { color: "#017F90", borderColor: "#017F90" },
];

export default TEMPORAL_CHART_PALETTE;
